import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { ShareholderDirector } from "../features/merchant/rep";
import { UploadedFile } from "../features/merchant/doc";

export interface BaseOrgDraft {
  userId: number; // Keep this required
  token: string;
  companyName: string | null;
  companyRegistrationNo: string | null;
  country?: string | null;
  address?: string | null;
  countryISOCode?: string | null;
  industryGroup?: string | null;
  industry?: string | null;
  gender?: string | null;
  employmentStatus?: string | null;
  employmentPosition?: string | null;
  dateOfBirth?: string | null;
  countryOfBirth?: string | null;
  legalEntityAddress?: string | null;
  legalStructure?: string | null;
  postalCode?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  accountType?: string | null;
  accountHolderName?: string | null;
  swiftCode?: string | null;
  bankAddress?: string | null;
  bankCountry?: string | null;
  currency?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  nameOfAuthorisedRepresentiative?: string | null;
  occupation?: string | null;
  numberofYears?: number | null;
  turnover?: number | null;
  nationality?: string | null;
  investmentAmount?: number | null;
  phoneNumber?: string | null;
  companyPhoneNumber?: string | null;
  repFirstName?: string | null;
  repLastName?: string | null;
  repTitle: string | null;
  userTitle?: string | null;
  userFirstName?: string | null;
  userLastName?: string | null;
  merchantTitle?: string | null;
  repEmail?: string | null;
  isPep?: boolean | null;
  authChecked?: boolean | null;
  directorChecked?: boolean | null;
  titleOfAuthorisedRepresentiative?: string | null;
  countryOfResidence?: string | null;
  countryOfIncorporation?: string | null;
  countryOfDomicile?: string | null;
  previousYearClosingInventory?: string | null;
  website?: string | null;
  numOfShareHoldersDirectors?: number | null;
  shareHoldersDirectors?: ShareholderDirector[] | null;
  emailOfAuthorisedRepresentiative?: string | null;
  jobTitle?: string | null;
  companyStartDate?: string | null;
  businessProfile?: UploadedFile[] | null;
  proofOfAddress?: UploadedFile[] | null;
  shareHoldersDirectorsRegisters?: UploadedFile[] | null;
  financialStatement?: UploadedFile[] | null;
  investmentMandate?: UploadedFile[] | null;
  fundManagerLicense?: UploadedFile[] | null;
  salaryProof?: UploadedFile[] | null;
  bankStatement?: UploadedFile[] | null;
  balanceSheetPAndLStatement?: UploadedFile[] | null;
  certificateOfIncorporation?: UploadedFile[] | null;
  supportingDocumentsWithSuppliers?: UploadedFile[] | null;
  crsSelCertificationForm?: UploadedFile[] | null;
  proofOfBankAccountDetails?: UploadedFile[] | null;
  companyConstitution?: UploadedFile[] | null;
  employerName?: string | null;
  referralSource?: string | null;
  otherReferral?: string | null;
  numberOfTaxResidenceCountries?: number | null;
  taxResidenceCountries?: Array<{
    country: string;
    tin: string;
    reason: string;
    explanation: string;
  }> | null;
}

export type OrgDraft = Partial<BaseOrgDraft>;

const saveOrgDraft = async (data: OrgDraft) => {
  try {
    const requestBody = {} as any;
    requestBody.userId = data.userId;

    for (const key in data) {
      const value = data[key as keyof BaseOrgDraft];
      if (value !== undefined && value !== null && value !== "") {
        requestBody[key] = value;
      }
    }

    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/save-org-draft`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${data.token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    throw new Error(message);
  }
};

export default saveOrgDraft;
